import React, { useState } from "react";

import SizeType from "../../../../helpers/deviceTypeSize";

import { Button, Drawer, Icon, Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { WORK_EFFECTIVENESS_FILTERS_SUCCESS } from "../../../../redux/modules/Analytics/actions";
import { ReloadOutlined } from "@ant-design/icons";

const { Option } = Select;

const Filters = ({ set_filtersVisible, filtersVisible }) => {
  const dispatch = useDispatch();
  const [filters, set_filters] = useState({
    technicians: [],
    assets_category: [],
    locations: [],
  });

  const { workEffectivenessReports } = useSelector(
    (state) => state.AnalyticsReducer
  );

  const { accounts } = useSelector((state) => state.accoutingReducer);

  const onChange = (value, key) => {
    const _filters = { ...filters };
    _filters[key] = value;
    set_filters(_filters);
  };
  const tProps = {
    multiple: true,
    placeholder: "Odaberi",
    style: {
      width: "100%",
    },
  };

  let cssClasses = "reportsFilters ";

  cssClasses += filtersVisible ? "height" : "";

  const drawerProps = {
    className: cssClasses,
    maskClosable: true,
    headerStyle: { padding: 6 },
    placement: "top",
    width: SizeType() === "xs" || SizeType() === "sm" ? "90%" : 850,
    height: 390,
    visible: filtersVisible,
    onClose: () => {
      set_filtersVisible(false);
      dispatch({ type: WORK_EFFECTIVENESS_FILTERS_SUCCESS, data: filters });
    },
    destroyOnClose: true,
    title: (
      <span>
        <Icon type="filter" theme="twoTone" /> Filteri
      </span>
    ),
  };

  return (
    <Drawer {...drawerProps}>
      <div
        style={{
          width: "96%",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          flexDirection: "row",
        }}
      >
        <div style={{ marginLeft: 18, width: 300 }}>
          <span>Tehnicari</span>
          <Select
            style={{ width: "100%" }}
            onChange={(val) => {
              onChange(val, "technicians");
            }}
            mode="multiple"
            allowClear={true}
            size={"large"}
            showSearch
            placeholder="Odaberi naziv"
            optionFilterProp="full_name"
            filterOption={(input, option) =>
              option.props.children
                .toLowerCase()
                .indexOf(input.toLowerCase()) >= 0
            }
          >
            {accounts.data
              .filter((x) => x.category === "TEH")
              .map((x) => (
                <Option key={x.id} value={x.id}>
                  {x.full_name}
                </Option>
              ))}
          </Select>
        </div>
        <div style={{ marginLeft: 18, width: "30px" }}>
          <span style={{ color: "#fff" }}>n</span>
          <Button
            onClick={() => {
              dispatch({
                type: WORK_EFFECTIVENESS_FILTERS_SUCCESS,
                data: filters,
              });
            }}
            children={"Primijeni"}
          />
        </div>
      </div>
    </Drawer>
  );
};

export default Filters;
